import PropTypes from 'prop-types'

import QuestionRow, {QUESTION_STATUS} from './QuestionRow'
import {CaretIcon} from './icons'
import {evergreenPrompt, findChapter} from './lifeStoryContent'
import {chapterHasAnswers, promptIsAnswered} from './lifeStoryTools'

import './questionListScreen.scss'

/**
 * Step two of the chapter picker (TK-3178): every question in the chosen
 * chapter, closed out by the chapter's evergreen "Is there anything else…"
 * question. Picking a row opens that question.
 *
 * Answered questions carry a check. The empty "not yet" ring only appears
 * once the chapter has an answer — in a chapter not yet begun every row
 * would carry it, so the markers are dropped and the questions sit flush.
 */
const QuestionListScreen = ({chapterKey, stories, openPrompt, openEvergreen, openChapterList, back, backLabel}) => {
  const chapter = findChapter(chapterKey)

  if (!chapter) return null

  const begun = chapterHasAnswers({chapterKey, stories})
  const unansweredStatus = begun ? QUESTION_STATUS.NEW : null

  return (
    <div className='question-list-screen'>
      <div className='ls-top'>
        <button className='ls-exit' onClick={back}>&larr; {backLabel}</button>
      </div>
      <div className='ls-switch'>
        <button aria-label='Choose a different chapter' className='ls-question-list-chapter' onClick={openChapterList}>
          <span>{chapter.name}</span>
          <CaretIcon />
        </button>
        <h1>What would you like to write about?</h1>
        <p className='ls-switch-sub'>
          There&rsquo;s no wrong answer here &mdash; pick whatever calls to you, and let the words come as they will.
        </p>
        <div className='ls-question-list'>
          {
            chapter.prompts.map(prompt => (
              <QuestionRow
                key={prompt.id}
                onClick={() => openPrompt(prompt.id)}
                question={prompt.question}
                status={promptIsAnswered({promptId: prompt.id, stories}) ? QUESTION_STATUS.ANSWERED : unansweredStatus}
              />
            ))
          }
          <QuestionRow
            evergreen
            onClick={openEvergreen}
            question={evergreenPrompt({chapter, promptId: null}).question}
            status={unansweredStatus}
          />
        </div>
      </div>
    </div>
  )
}

QuestionListScreen.propTypes = {
  back: PropTypes.func.isRequired,
  backLabel: PropTypes.string.isRequired,
  chapterKey: PropTypes.string.isRequired,
  openChapterList: PropTypes.func.isRequired,
  openEvergreen: PropTypes.func.isRequired,
  openPrompt: PropTypes.func.isRequired,
  stories: PropTypes.array.isRequired
}

export default QuestionListScreen
